import axios from 'axios';

import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;

export const eventNameChange = (eventName) => {
    return {
        type: 'EVENT_NAME_CHANGE',
        payload: eventName
    };
};

export const eventDescriptionChange = (eventDescription) => {
    return {
        type: 'EVENT_DESCRIPTION_CHANGE',
        payload: eventDescription
    };
};

export const eventLinkChange = (eventLink) => {
    return {
        type: 'EVENT_LINK_CHANGE',
        payload: eventLink
    };
};

// export const eventTimeChange = (eventTime) => {
//     return {
//         type: 'EVENT_TIME_CHANGE',
//         payload: eventTime
//     };
// };

export const eventMessageChange = (eventMessage) => {
    return {
        type: 'EVENT_MESSAGE_CHANGE',
        payload: eventMessage
    };
};



// WEBPACK FOOTER //
// ./src/actions/Events/EventAction.js